import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  margin: 16px;
`

const Heading = styled.h2``

const Preamble = styled.p``

/**
 * @param {{
 *  service: {
 *    confirmationHeading: string
 *    confirmationText: string
 *  }
 * }} props
 */
export const RequestFormCompleted = ({ service }) => (
  <Container>
    <Heading>{service.confirmationHeading}</Heading>
    <Preamble>{service.confirmationText}</Preamble>
  </Container>
)
